<template>
  <div>
    <div class="head">
      <a class="logo"><img src="../assets/logo.png" alt="" /></a>
      <a class="back" @click="pageBack()" v-if="cityQuery.hidBtn !== ''"
        >返回</a
      >
      <div class="tit">{{ cityQuery.cityName }}实时交易结算数据中心</div>
      <div class="time">{{ now }}</div>
    </div>
    <div class="main">
      <div class="numlist">
        <div class="item" v-for="(item, index) in numList" :key="index">
          <img :src="item.icon" alt="" />
          <div class="txt">
            <p>
              <span
                ><b>{{ item.num }}</b
                >{{ item.unit }}</span
              >
              <i class="up" v-if="item.isup">⬆</i>
            </p>
            <h6>{{ item.name }}</h6>
          </div>
        </div>
      </div>
      <div class="boths">
        <div class="boxs">
          <div class="tit">
            <h3 v-if="!getLoadAll()">商家交易排行</h3>
            <h3 v-if="getLoadAll()">城市交易额排行</h3>
            <div class="tabs" v-if="!getLoadAll()">
              <span
                :class="[{ on: tabflaga === 1 }]"
                @click="loadStoreRanking(1)"
                >现金</span
              >
              <span
                :class="[{ on: tabflaga === 2 }]"
                @click="loadStoreRanking(2)"
                >积分</span
              >
            </div>
            <div class="tabs" v-if="getLoadAll()">
              <span
                :class="[{ on: tabflaga === 1 }]"
                @click="loadCityRanking(1)"
                >现金</span
              >
              <span
                :class="[{ on: tabflaga === 2 }]"
                @click="loadCityRanking(2)"
                >积分</span
              >
            </div>
          </div>
          <div class="lists">
            <div class="child">
              <div class="litem">排行</div>
              <div class="litem">{{ getLoadAll() ? "城市" : "商家" }}名称</div>
              <div class="litem">
                <span v-if="tabflaga === 1">现金</span>
                <span v-if="tabflaga === 2">积分</span>
              </div>
            </div>
            <div class="scroll scrollbar">
              <div
                v-if="!getLoadAll()"
                class="child lista"
                v-for="(item, index) in storeRankList"
                :key="index"
              >
                <div class="litem" v-if="index === 0">
                  <img src="../assets/a10.png" alt="" />
                </div>
                <div class="litem" v-if="index === 1">
                  <img src="../assets/a11.png" alt="" />
                </div>
                <div class="litem" v-if="index === 2">
                  <img src="../assets/a12.png" alt="" />
                </div>
                <div class="litem" v-if="index > 2" style="font-weight: bold">
                  {{ parseInt(index) + 1 }}
                </div>
                <div class="litem">{{ item.storeName }}</div>
                <div class="litem">
                  <span v-if="tabflaga === 1">{{ item.money }}元</span>
                  <span v-if="tabflaga === 2">{{ item.score }}积分</span>
                </div>
              </div>
              <div
                v-if="getLoadAll()"
                class="child lista"
                v-for="(item, index) in cityTradeRankList"
                :key="index"
              >
                <div class="litem" v-if="index === 0">
                  <img src="../assets/a10.png" alt="" />
                </div>
                <div class="litem" v-if="index === 1">
                  <img src="../assets/a11.png" alt="" />
                </div>
                <div class="litem" v-if="index === 2">
                  <img src="../assets/a12.png" alt="" />
                </div>
                <div class="litem" v-if="index > 2" style="font-weight: bold">
                  {{ parseInt(index) + 1 }}
                </div>
                <div class="litem">{{ item.cityName }}</div>
                <div class="litem">
                  <span v-if="tabflaga === 1">{{ item.money }}元</span>
                  <span v-if="tabflaga === 2">{{ item.score }}积分</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="maps">
          <div class="return_div" v-if="cityQuery.hidBtn !== ''">
            <h3
              v-if="cityQuery.level === 3"
              class="return_back"
              @click="returnCity"
            >
              查看市级
            </h3>
          </div>

          <div id="main" style="width: 100%; height: 37.4vh"></div>
        </div>
        <div class="boxs">
          <div class="tit">
            <h3>近期数据</h3>
            <div class="tabs">
              <!-- <span :class="[{'on':tabflagb===0}]" @click="loadLiveProductRanking(0)">直播数据</span> -->
              <span
                :class="[{ on: tabflagb === 1 }]"
                @click="loadLiveProductRanking(1)"
                >打赏数据</span
              >
            </div>
          </div>
          <div class="lists">
            <div class="child">
              <div class="litem">排行</div>
              <div class="litem">主播名称</div>
              <div class="litem">
                <span v-if="tabflagb === 0">直播带货</span>
                <span v-if="tabflagb === 1">打赏数据</span>
              </div>
            </div>
            <div class="scroll scrollbar">
              <div
                class="child lista"
                v-for="(item, index) in liveRankList"
                :key="index"
              >
                <div class="litem" v-if="index === 0">
                  <img src="../assets/a10.png" alt="" />
                </div>
                <div class="litem" v-if="index === 1">
                  <img src="../assets/a11.png" alt="" />
                </div>
                <div class="litem" v-if="index === 2">
                  <img src="../assets/a12.png" alt="" />
                </div>
                <div class="litem" v-if="index > 2" style="font-weight: bold">
                  {{ parseInt(index) + 1 }}
                </div>
                <div
                  class="litem txmz"
                  style="justify-content: left; padding-left: 15px"
                >
                  <img
                    class="tx"
                    :src="
                      item.userHead.startsWith('http')
                        ? item.userHead
                        : ossUrl + item.userHead
                    "
                    alt=""
                  />
                  {{ item.userName }}
                </div>
                <div class="litem">
                  <span v-if="tabflagb === 0">{{ item.money }}元</span>
                  <span v-if="tabflagb === 1">{{ item.score }}积分</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="boths down">
        <div class="boxs size2">
          <div class="tit bg2">
            <h3>现金实时交易</h3>
          </div>
          <div class="lists">
            <div class="child">
              <div class="litem">用户名称</div>
              <div class="litem">交易金额</div>
              <div class="litem">交易方式</div>
              <div class="litem">商家名称</div>
            </div>
            <!-- <div class="scroll"> -->
            <vue-seamless-scroll
              :data="moneyTradeList"
              :class-option="defaultOption"
              class="scroll"
              ref="seamlessScrollMoney"
            >
              <div
                class="child lista"
                v-for="(item, index) in moneyTradeList"
                :key="index"
                :style="{
                  backgroundColor:
                    index === 0 && autoBackColorMoney !== ''
                      ? autoBackColorMoney
                      : '',
                }"
              >
                <div
                  class="litem txmz"
                  style="justify-content: left; padding-left: 15px"
                >
                  <img
                    class="tx"
                    :src="
                      item.userHead.startsWith('http')
                        ? item.userHead
                        : ossUrl + item.userHead
                    "
                    alt=""
                  />
                  {{ item.userName }}
                </div>
                <div class="litem">{{ item.tradeMoney }}</div>
                <div class="litem">{{ payType[item.buyType] }}</div>
                <div class="litem">{{ item.storeName }}</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>

        <div class="boxs size3">
          <div class="tit bg2">
            <h3>积分实时交易</h3>
          </div>
          <div class="lists">
            <div class="child">
              <div class="litem">用户名称</div>
              <div class="litem zhai">积分兑换</div>
              <div class="litem">商品名称</div>
              <div class="litem kuan">商家名称</div>
              <div class="litem">产生佣金</div>
              <div class="litem">合伙人收益</div>
            </div>
            <!-- <div class="scroll"> -->
            <vue-seamless-scroll
              :data="scoreTradeList"
              :class-option="defaultOption"
              class="scroll"
              ref="seamlessScrollScore"
            >
              <div
                class="child lista"
                v-for="(item, index) in scoreTradeList"
                :key="index"
                :style="{
                  backgroundColor:
                    index === 0 && autoBackColorScore !== ''
                      ? autoBackColorScore
                      : '',
                }"
              >
                <div
                  class="litem txmz"
                  style="justify-content: left; padding-left: 15px"
                >
                  <img
                    class="tx"
                    :src="
                      item.userHead.startsWith('http')
                        ? item.userHead
                        : ossUrl + item.userHead
                    "
                    alt=""
                  />
                  {{ item.userName }}
                </div>
                <div class="litem zhai">{{ item.tradeMoney }}</div>
                <div class="litem">{{ item.productNameOfScore }}</div>
                <div class="litem kuan">{{ item.storeNameOfScore }}</div>
                <div class="litem">{{ item.commission }}元</div>
                <div class="litem">{{ item.partnerMoney }}元</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
    <div class="pops" v-show="showpop">
      <div class="bg"></div>
      <div class="mid">
        <i class="top"></i>
        <i class="right"></i>
        <i class="down"></i>
        <i class="left"></i>
        <a class="close" @click="showpop = false">关闭</a>
        <div class="citys">
          <h3>
            <span>{{ childname }}</span>
          </h3>
          <div id="main2" style="width: 67vw; height: 54vh"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import * as echarts from "echarts";
import {
  cityTotalInfo,
  cityTradeRanking,
  getAreaByName,
  getAreaMapJson,
  getStoreRanking,
  liveGiftRanking,
  liveProductRanking,
  moneyTradeRealTime,
  scoreTradeRealTime,
} from "../api/home";
import {
  getAreaAll,
  getPartnerCount,
  getTodayTradeVolume,
  getUserNewCount,
} from "../api";
import { globalConfig } from "../../config/global";
import { scrSocket } from "../utils/WebSocket";

export default {
  name: "index",
  components: {
    vueSeamlessScroll,
  },
  computed: {
    defaultOption() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  data() {
    return {
      numList: [
        {
          icon: require("@/assets/a14.png"),
          num: 0,
          unit: "人",
          isup: true,
          name: "今日新增会员",
        },
        {
          icon: require("@/assets/a14.png"),
          num: 0,
          unit: "人",
          isup: true,
          name: "本月新增会员",
        },
        {
          icon: require("@/assets/a14.png"),
          num: 0,
          unit: "人",
          isup: false,
          name: "会员总数",
        },
        {
          icon: require("@/assets/a15.png"),
          num: 0,
          unit: "人",
          isup: false,
          name: "合伙人总数",
        },
        {
          icon: require("@/assets/a16.png"),
          num: 0,
          unit: "元",
          isup: false,
          name: "今日现金交易额",
        },
        {
          icon: require("@/assets/a17.png"),
          num: 0,
          unit: "积分",
          isup: false,
          name: "今日积分交易额",
        },
      ],
      timer: null,
      now: "",
      tabflaga: 1,
      tabflagb: 1,
      payType: { 1: "微信支付", 2: "支付宝支付" },
      showpop: false,
      childname: "", //弹窗地图所属地区
      geoCoordMap: {},
      cityData: [],
      cityQuery: {},
      cityMap: {},
      countyIdList: [],
      storeRankList: [],
      moneyTradeList: [],
      scoreTradeList: [],
      liveRankList: [],
      localCountyList: [],
      cityStoreInfo: [],
      autoBackColorMoney: "",
      autoBackColorScore: "",
      cityTradeRankList: [],
      ossUrl: globalConfig.ossUrl,
      cityid: "",
    };
  },
  mounted() {
    this.cityMap = new Map();
    const that = this;

    this.cityQuery.cityName = this.$route.query.cityName;
    this.cityQuery.cityCode = this.$route.query.cityCode;
    this.cityQuery.hidBtn = this.$route.query.hidBtn;
    //组装区域map
    let cityMapItem = window.sessionStorage.getItem("cityMap");

    if (cityMapItem === null || cityMapItem === "") {
      getAreaAll({})
        .then((res) => {
          let citystemp = [];

          res.list.forEach((item) => {
            citystemp = citystemp.concat(item.childList);
          });

          citystemp.forEach((item) => {
            that.cityMap.set(item.areaId, item.childList);
          });
          window.sessionStorage.setItem(
            "cityMap",
            JSON.stringify(that.cityMap)
          );
        })
        .catch((e) => {
          console.log(e.message);
        });
    } else {
      let cityList = JSON.parse(cityMapItem);
      for (let i = 0; i < cityList.length; i++) {
        this.cityMap.set(cityList[i][0], cityList[i][1]);
      }
    }

    //全国则加载城市交易排行
    if (this.getLoadAll()) {
      this.loadCityRanking(1);
    }

    this.loadData();
    this.reLoad();
  },

  methods: {
    drawCharts(params) {
      let that = this;

      getAreaMapJson(params)
        .then((res) => {
          echarts.registerMap("shengtu", res);
          let chinaMap = echarts.init(document.getElementById("main"));

          chinaMap.setOption(
            {
              // 进行相关配置
              tooltip: {
                // 鼠标移到图里面的浮动提示框
                backgroundColor: "transparent", //提示框背景色
                borderColor: "transparent", //边框夜色
                textStyle: {
                  color: "rgba(255, 255, 255, 1)", //文字颜色
                },
                //自定义提示框自动调用函数
                formatter: function (params) {
                  let showname = params;
                  return `
              <div class="popline">

                <div class="popmap" style="display: block; width:170px; height: 110px; padding:8px 10px 0; font-size: 12px; color: #fff; line-height: 18px; ">
                    <img style=" display: block; width: 170px; height:110px; position:absolute; left:0; top:0; z-index:1;" src="${
                      showname.data.bgsrc
                    }" alt="">
                    <h3 style="display: flex; align-items: center; font-size:14px; line-height: 24px; margin-bottom: 0px; position:relative; z-index:2;">
                      <img style=" display: block; width: 20px; margin-right: 5px;" src="${
                        showname.data.src
                      }" alt="">
                      ${showname.data ? showname.data.storeName : "暂无信息"}
                    </h3>
                    <p style="position:relative; z-index:2;">现金交易额: <b style="font-size:13px;">${
                      showname.data ? showname.data.money + "元" : "暂无信息"
                    }</b></p>
                    <p style="position:relative; z-index:2;">积分交易额:<b style="font-size:13px;">${
                      showname.data ? showname.data.score + "积分" : "暂无信息"
                    }</b></p>
                    <p style="position:relative; z-index:2;">地址:${
                      showname.data ? showname.data.address : "暂无信息"
                    }</p>
                </div>
              </div>
              `;
                },
              },
              visualMap: {
                min: 0,
                max: 2000,
                left: 20,
                top: 20,
                showLabel: !0,
                itemWidth: 10,
                itemHeight: 10,
                itemRadius: 10,
                text: ["", ""],
                textStyle: {
                  color: "#fff",
                },
                pieces: [
                  {
                    gt: 50000,
                    label: "> 50000",
                    color: "#f7c824",
                  },
                  {
                    gte: 10000,
                    lte: 50000,
                    label: "10000 - 50000",
                    color: "#26a4de",
                  },
                  {
                    gte: 5000,
                    lte: 10000,
                    label: "5000 - 10000",
                    color: "#f394ff",
                  },
                  {
                    gte: 0,
                    lt: 5000,
                    label: "< 5000",
                    color: "#2bebc8",
                  },
                ],
                show: !0,
              },
              geo: [
                {
                  show: true,
                  map: "shengtu",
                  zoom: 1.0,
                  layoutCenter: ["50%", "50%"],
                  layoutSize: "100%",
                  label: {
                    normal: {
                      //静态的时候展示样式
                      show: true, //是否显示地图省份得名称
                      textStyle: {
                        color: "#000",
                        fontSize: 12,
                        fontFamily: "Arial",
                      },
                    },
                    emphasis: {
                      //动态展示的样式
                      color: "#fff",
                    },
                  },

                  blur: {
                    label: { show: true, color: "#000" },
                  },
                  roam: false, // 是否开启鼠标滚轮缩放
                  itemStyle: {
                    normal: {
                      label: {
                        show: true,
                        color: "#fff",
                      },
                      color: "#fff",
                      borderColor: "rgba(104, 166, 266,0.8)",
                      borderWidth: 1.5,
                      areaColor: {
                        type: "linear-gradient",
                        x: 0,
                        y: 1000,
                        x2: 0,
                        y2: 0,
                        colorStops: [
                          {
                            offset: 0.5,
                            color: "rgba(14,82,126,0.8)", // 0% 处的颜色
                          },
                          {
                            offset: 1,
                            color: "rgba(14,82,126,0.5)", // 100% 处的颜色
                          },
                        ],
                        global: true, // 缺省为 false
                      },
                    },
                    emphasis: {
                      label: {
                        show: true,
                        color: "#fff",
                      },
                      borderWidth: 3,
                      borderColor: "rgba(23, 212, 213,0.8)",
                      shadowColor: "rgba(23, 212, 213,0)",
                      shadowBlur: 30,
                      textStyle: {
                        color: "#fff",
                        fontSize: 12,
                        backgroundColor: "transparent",
                      },
                      areaColor: new echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                          {
                            offset: 0,
                            color: "rgba(23, 212, 213,0.6)",
                          },
                          {
                            offset: 1,
                            color: "rgba(23, 212, 213,0.3)",
                          },
                        ],
                        false
                      ),
                    },
                  },
                },
                {
                  type: "map",
                  map: "shengtu",
                  zlevel: -2,
                  zoom: 1.0,
                  layoutCenter: ["50%", "51.4%"],
                  layoutSize: "100%",
                  roam: false,
                  silent: true,
                  itemStyle: {
                    normal: {
                      borderColor: "rgba(104, 166, 266,0.5)",
                      shadowColor: "rgba(11, 81, 131,0.8)",
                      shadowOffsetY: 5,
                      shadowBlur: 15,
                      areaColor: "rgba(14,82,126,0.8)",
                    },
                  },
                },
                {
                  type: "map",
                  map: "shengtu",
                  zlevel: -3,
                  zoom: 1.0,
                  layoutCenter: ["50%", "52.4%"],
                  layoutSize: "100%",
                  roam: false,
                  silent: true,
                  itemStyle: {
                    normal: {
                      borderColor: "rgba(104, 166, 266,0.5)",
                      shadowColor: "rgba(11, 81, 131,0.8)",
                      shadowOffsetY: 5,
                      shadowBlur: 15,
                      areaColor: "rgba(14,82,126,0.8)",
                    },
                  },
                },
              ],
              series: [
                {
                  name: "点",
                  type: "scatter",
                  coordinateSystem: "geo",
                  // symbol: 'pin',
                  // symbol: 'image://img/img3.png',
                  // symbolSize: [15,20],
                  label: {
                    normal: {
                      show: true,
                      formatter: function (value) {
                        return value.name;
                      },
                      position: "right",
                      textStyle: {
                        color: "transparent",
                        fontSize: 14,
                      },
                    },
                  },

                  zlevel: 6,
                  data: that.convertData(that.cityData),
                },
                {
                  type: "effectScatter",
                  coordinateSystem: "geo",
                  symbolSize: 3,
                  showEffectOn: "render",
                  zlevel: 1,
                  rippleEffect: {
                    scale: 6,
                    brushType: "stroke",
                    color: "#04B9FF",
                  },
                  itemStyle: {
                    normal: {
                      color: "#1DE9B6",
                      shadowBlur: 5,
                      shadowColor: "#333",
                    },
                  },
                  data: that.convertData(that.cityData),
                },
              ],
            },
            true
          );

          chinaMap.on("click", (data) => {
            console.log(data);
            let county = this.localCountyList.find(
              (item) => item.fullname === data.name
            );
            this.$router.push({
              path: "/home",
              query: { cityName: county.fullname, cityCode: county.cityCode },
            });
            location.reload();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    convertData(data) {
      let res = [];
      for (var i = 0; i < this.cityStoreInfo.length; i++) {
        let info = { ...this.cityStoreInfo[i] };
        info.src = require("@/assets/a13.png");
        info.bgsrc = require("@/assets/a18.png");
        info.value = info.lngAndLat.concat(info.allMoney);
        res.push(info);
      }
      console.log(res.length);
      return res;
    },
    returnCity() {
      console.log(1);
      this.$router.push({
        path: "/home",
        query: {
          cityName: this.cityQuery.parentName,
          cityCode: this.cityQuery.parentCityCode,
        },
      });
      location.reload();
    },
    loadData() {
      const that = this;

      getAreaByName({ cityCode: this.cityQuery.cityCode })
        .then((res) => {
          let code = this.cityQuery.cityCode + "_full";
          let cityId = "0";

          if (res.model !== null) {
            that.cityQuery.level = res.model.level;
            that.cityQuery.cityName = res.model.fullname;
            that.cityQuery.parentName = res.model.parentName;
            that.cityQuery.parentCityCode = res.model.parentCityCode;

            code =
              res.model.level === 3
                ? res.model.cityCode
                : res.model.cityCode + "_full";

            let countyIdList = [];
            if (that.cityQuery.level === 2) {
              let countyList = that.cityMap.get(res.model.areaId);
              that.localCountyList = countyList;
              countyIdList = countyList.map((item) => item.areaId);
            }
            countyIdList.push(res.model.areaId);
            that.countyIdList = countyIdList;
            cityId = res.model.areaId;
            that.cityid = res.model.areaId;
          }
          scrSocket(cityId, (msg) => {
            // this.moneyTradeList = [msg[0]];
            // that.moneyTradeList[0] = msg[0];

            // console.log(that.moneyTradeList.shift())
            // this.moneyTradeList.push(msg[0])

            if (msg[0].buyType === "1") {
              that.moneyTradeList.unshift(msg[0]);
              that.moneyTradeList.pop();
              that.moneyTradeList.push();
              that.autoBackColorMoney = "#0F4FD4";
            } else {
              that.scoreTradeList.unshift(msg[0]);
              that.scoreTradeList.pop();
              that.scoreTradeList.push();
              that.autoBackColorScore = "#0F4FD4";
            }
          });

          cityTotalInfo({ areaIdList: this.countyIdList })
            .then((res) => {
              that.cityStoreInfo = res.list;
              this.drawCharts(code);
            })
            .catch((e) => {
              console.log(e.message);
            });

          that.loadUserCount([]);
          that.loadTradeData();
          //默认查询现金交易
          that.loadStoreRanking(1);

          that.loadRealTimeList(this.countyIdList);

          //默认查询直播带货排行
          that.loadLiveProductRanking(1);
        })
        .catch((e) => {
          console.log(e.message);
        });
    },
    loadUserCount(countyIdList) {
      let op = {
        nowType: "now_day",
        areaIdList: countyIdList,
      };
      const that = this;
      //查询今日会员数量
      getUserNewCount(op)
        .then((res) => {
          that.numList[0].num = res.data;
        })
        .catch((e) => {
          console.log(e.message);
        });

      op.nowType = "now_month";
      //查询本月会员数量
      getUserNewCount(op)
        .then((res) => {
          that.numList[1].num = res.data;
        })
        .catch((e) => {
          console.log(e.message);
        });

      //查询当前地区全部会员数量
      getUserNewCount({ areaIdList: countyIdList })
        .then((res) => {
          that.numList[2].num = res.data;
        })
        .catch((e) => {
          console.log(e.message);
        });

      //查询合伙人数量
      getPartnerCount({ areaIdList: countyIdList })
        .then((res) => {
          that.numList[3].num = res.data;
          // if (that.getLoadAll()) {
          that.numList[3].num += 2000;
          // }
        })
        .catch((e) => {
          console.log(e.message);
        });
    },
    loadTradeData() {
      const that = this;

      let op = {
        tradeType: "money",
        areaIdList: this.cityid ? [this.cityid] : [],
      };

      //查询今日现金交易量
      getTodayTradeVolume(op)
        .then((res) => {
          that.numList[4].num = res.data;
        })
        .catch((e) => {
          console.log(e.message);
        });

      op.tradeType = "score";
      //查询今日积分交易量
      getTodayTradeVolume(op)
        .then((res) => {
          that.numList[5].num = res.data;
        })
        .catch((e) => {
          console.log(e.message);
        });
    },
    loadStoreRanking(buyType) {
      const that = this;

      this.tabflaga = buyType;

      let op = {
        limitCount: 20,
        buyType: buyType,
        areaIdList: this.countyIdList,
      };

      getStoreRanking(op)
        .then((res) => {
          that.storeRankList = res.list;
        })
        .catch((e) => {
          console.log(e.message);
        });
    },
    loadRealTimeList(countyIdList) {
      const that = this;

      let op = {
        limitCount: 20,
        areaIdList: countyIdList,
      };

      moneyTradeRealTime(op)
        .then((res) => {
          console.log(res);
          that.moneyTradeList = res.list;
        })
        .catch((e) => {
          console.log(e.message);
        });

      scoreTradeRealTime(op)
        .then((res) => {
          that.scoreTradeList = res.list;
        })
        .catch((e) => {
          console.log(e.message);
        });
    },
    loadLiveProductRanking(loadType) {
      this.tabflagb = loadType;

      const that = this;

      let op = {
        areaIdList: this.countyIdList,
        limitCount: 20,
      };

      if (loadType === 0) {
        liveProductRanking(op)
          .then((res) => {
            that.liveRankList = res.list;
          })
          .catch((e) => {
            console.log(e.message);
          });
        return;
      }

      liveGiftRanking(op)
        .then((res) => {
          that.liveRankList = res.list;
        })
        .catch((e) => {
          console.log(e.message);
        });
    },
    loadCityRanking(buyType) {
      const that = this;

      this.tabflaga = buyType;

      let op = {
        buyType: buyType,
        limitCount: 20,
      };

      cityTradeRanking(op)
        .then((res) => {
          that.cityTradeRankList = res.list;
        })
        .catch((e) => {
          console.log(e.message);
        });
    },
    async reLoad() {
      setInterval(() => {
        console.log(this.countyIdList);

        if (this.countyIdList === null) {
          return;
        }

        this.loadUserCount([]);
        this.loadTradeData();
        //默认查询现金交易
        this.loadStoreRanking(1);

        //默认查询直播带货排行
        this.loadLiveProductRanking(1);
      }, 100000);
    },
    pageBack() {
      this.$router.push("/");
    },
    getLoadAll() {
      return this.cityQuery.cityCode === "100000";
    },
  },
  created() {
    // echarts.registerMap('shengtu', geoJson)
    let that = this;

    var date = new Date();
    var year = date.getFullYear(); //获取年份
    var month = date.getMonth() + 1; //获取月份
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //获取日期
    var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //获取小时
    var minutes =
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); //获取分钟
    var seconds =
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); //获取秒钟
    that.now =
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds;

    setInterval(function () {
      var date = new Date();
      var year = date.getFullYear(); //获取年份
      var month = date.getMonth() + 1; //获取月份
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //获取日期
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //获取小时
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); //获取分钟
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); //获取秒钟
      that.now =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
    }, 1000);
  },
  watch: {
    /**
     * 通过监听器刷新滚动列表
     */
    moneyTradeList(newVal, oldVal) {
      this.$nextTick(() => {
        this.$refs.seamlessScrollMoney.reset();
      });
    },
    scoreTradeList(newVal, oldVal) {
      this.$nextTick(() => {
        this.$refs.seamlessScrollScore.reset();
      });
    },
    autoBackColorMoney(newVal, oldVal) {
      if (newVal !== null && newVal !== "") {
        setTimeout(() => {
          this.autoBackColorMoney = "";
          this.$refs.seamlessScrollMoney.reset();
        }, 20000);
      }
    },
    autoBackColorScore(newVal, oldVal) {
      if (newVal !== null && newVal !== "") {
        setTimeout(() => {
          this.autoBackColorScore = "";
          this.$refs.seamlessScrollScore.reset();
        }, 20000);
      }
    },
  },
};
</script>


<style scoped>
.scrollbar {
  overflow-y: auto;
}

.scrollbar::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #0c2965;
}

.boths {
  height: 37.4vh;
  overflow: hidden;
  margin-top: 1.8vh;
}

.boxs {
  width: 29.5vw;
  float: left;
  height: 37.4vh;
  background-color: #0c2965;
  border-radius: 8px;
  border: solid 1px #1347ab;
  overflow: hidden;
}

.boxs:last-child {
  float: right;
}

.boxs .tit {
  height: 5.5vh;
  background: url(../assets/a02.png) no-repeat center center / 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 3vw 0 1.5vw;
  font-size: 1.1vw;
  color: #00d4ff;
  position: relative;
}

.boxs .tit.bg2 {
  background-image: url(../assets/a04.png);
}

.boxs .tit .tabs {
  position: absolute;
  right: 3vw;
  bottom: 0px;
  z-index: 3;
}

.boxs .tit span {
  margin-left: 0.5vw;
  padding: 0 0.8vw;
  font-size: 0.95vw;
  font-weight: bold;
  height: 3.5vh;
  border-radius: 4px;
  border: solid 1px #00d4ff;
  color: #00d4ff;
  margin-bottom: 1.1vh;
  float: left;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.boxs .tit span.on {
  height: 4.6vh;
  margin-bottom: 0;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  background-color: #0c2965;
}

.boxs .lists {
  /* border-right: none;*/
  height: 26.4vh;
  height: 31.9vh;
}

.boxs .lists .child {
  overflow: hidden;
  background-color: #0c2965;
}

.boxs .lists .child .litem {
  width: 42.5%;
  float: left;
  height: 5.5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9vw;
  color: #00d4ff;
  border-right: 1px solid #0e3990;
}

.boxs .lists .child .litem:nth-child(1) {
  width: 15%;
}

.boxs .lists .scroll .lista:nth-child(2n + 1) {
  background-color: #14316d;
}

.boxs .lists .lista .litem {
  height: 4.4vh;
  font-size: 0.8vw;
}

.boxs .lists .scroll {
  height: 26.4vh;
}

.boxs .lists > .child {
  padding-right: 4px;
}

.boxs .lists .child .litem:last-child {
  border-right: none;
}

.boxs .lists .child .litem > img {
  display: block;
  height: 2.78vh;
}

.boxs .lists .child .litem > img.tx {
  display: block;
  height: 3vh;
  width: 3vh;
  object-fit: cover;
  margin-right: 4px;
  border-radius: 15px;
}

.maps {
  width: 39.3vw;
  float: left;
  height: 37.4vh;
  background: url(../assets/a29.png) no-repeat center bottom / 80% auto;
}

.boxs.size2 {
  width: 42.2vw;
  width: 43vw;
}

.boths.down .boxs {
  height: 34.9vh;
}

.boths.down .boxs .lists .child .litem {
  height: 4.2vh;
}

.boths.down .boxs .lists .lista .litem {
  height: 4.2vh;
}

.boths.down .boxs.size2 .lists .child .litem {
  width: 25%;
}

.boths.down .boxs.size2 .lists .child .litem:nth-child(1) {
  width: 25%;
}

.boths.down .boxs.size2 .lists > .child {
  padding-right: 0;
}

.boxs.size2 .lists .scroll {
  height: 25.2vh;
  overflow: hidden;
}

.boxs.size3 {
  width: 55.2vw;
  float: right;
}

.boths.down .boxs.size3 .lists .child .litem {
  width: 16%;
}

.boths.down .boxs.size3 .lists .child .litem.zhai {
  width: 14%;
}

.boths.down .boxs.size3 .lists .child .litem.kuan {
  width: 18%;
}

.boths.down .boxs.size3 .lists .child .litem:nth-child(1) {
  width: 20%;
}

.boths.down .boxs.size3 .lists > .child {
  padding-right: 0;
}

.boxs.size3 .lists .scroll {
  height: 25.2vh;
  overflow: hidden;
}

.pops {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
}

.pops .bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.65);
}

.pops .mid {
  position: absolute;
  left: 15vw;
  right: 15vw;
  top: 15vh;
  bottom: 15vh;
  z-index: 3;
  background-color: #07215d;
  border: solid 1px #00d4ff;
  padding: 5vh 1.5vw 4vh;
}

.pops .mid .close {
  position: absolute;
  right: 1.5vw;
  top: 0vh;
  font-size: 0.8vw;
  color: #00bfe9;
  cursor: pointer;
  z-index: 3;
  line-height: 4vh;
}

.pops .mid h3 {
  overflow: hidden;
  margin-bottom: 24px;
}

.pops .mid h3 span {
  font-size: 0.9vw;
  color: #00bfe9;
  height: 5.7vh;
  background: url(../assets/a26.png) no-repeat center center / 100% 100%;
  padding: 0 2vw 0 1.2vw;
  float: left;
  display: flex;
  align-items: center;
}

.pops .mid > i {
  width: 30px;
  height: 30px;
  border: 2px solid #00d4ff;
  position: absolute;
}

.pops .mid > i.top {
  left: -12px;
  top: -12px;
  border-right: none;
  border-bottom: none;
}

.pops .mid > i.right {
  right: -12px;
  top: -12px;
  border-left: none;
  border-bottom: none;
}

.pops .mid > i.down {
  left: -12px;
  bottom: -12px;
  border-right: none;
  border-top: none;
}

.pops .mid > i.left {
  right: -12px;
  bottom: -12px;
  border-left: none;
  border-top: none;
}

.pops .line {
  position: fixed;
  right: 4vw;
  top: 6.7vh;
  width: 15vw;
  z-index: 2;
}

.return_back {
  text-decoration: none;
  display: inline-block;
  font-weight: bold;
  line-height: 4.4vh;
  cursor: pointer;
  background: url(../assets/a01.png) no-repeat center center / 80% 80%;
  height: 4.4vh;
  padding: 0 1.5vw;
  font-size: 0.9vw;
  color: #00bfe9;
}

.return_div {
  float: right;
  position: absolute;
  z-index: 10;
  margin-left: 33%;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue